import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { membersKeys } from '../members.keys';
import { updateRole } from '../members.service';
export const useUpdateRole = (userId, subdomain = getSubdomain()) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (role) => updateRole({ subdomain, userId, role }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: membersKeys.members(subdomain) });
        },
    });
};
